import React from 'react';
import { Skeleton } from '../ui/skeleton';

/**
 * Skeleton loader for message/conversation cards
 */
const MessageCardSkeleton = () => {
  return (
    <div className="border rounded-lg p-4">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          {/* Contact name */}
          <div className="flex items-center gap-2 mb-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-5 w-32" />
          </div>
          {/* Message preview */}
          <Skeleton className="h-4 w-full mb-1" />
          <Skeleton className="h-3 w-2/3" />
        </div>
        {/* Timestamp and unread badge */}
        <div className="text-right ml-4">
          <Skeleton className="h-3 w-16 mb-1" />
          <Skeleton className="h-5 w-5 rounded-full ml-auto" />
        </div>
      </div>
    </div>
  );
};

/**
 * List of skeleton cards for messages loading state
 */
export const MessageListSkeleton = ({ count = 4 }) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, idx) => (
        <MessageCardSkeleton key={idx} />
      ))}
    </div>
  );
};

export default MessageCardSkeleton;
